import {createSettingsParams, SettingsParamType} from '@wix/tpa-settings'

import {textMetadata} from '../../../../../utils/builderMetadata'

export type TextsSettingsParams = {
  titleReservedText: SettingsParamType.Text
  titleRequestedText: SettingsParamType.Text
}

export const textsSettingsParams = createSettingsParams<TextsSettingsParams>({
  titleReservedText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('uou-reservations.reservation-confirmation.title'),
    metadata: textMetadata(
      'uou-reservations.reservation-confirmation.title',
      'Title shown when the reservation is confirmed',
    ),
  },
  titleRequestedText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('uou-reservations.reservation-confirmation.requested-title'),
    metadata: textMetadata(
      'uou-reservations.reservation-confirmation.requested-title',
      'Title shown when the reservation is a request waiting for approval',
    ),
  },
})
